import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import Insta from "./Icons/Insta";
import Facebook from "./Icons/Facebook";
import TikTok from "./Icons/TikTok";

const Header = ({ sidebar }) => {
  const [height, setHeight] = useState(100);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setHeight(50);
      } else {
        setHeight(100);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <header
      style={{
        height: height + "px",
        ...(sidebar ? { filter: "blur(5px)", pointerEvents: "none" } : {}),
      }}
    >
      <div className="container">
        <div className="header-left">
          <img
            src="./assets/logo.png"
            alt="logo entreprise"
            style={{ width: height + "px" }}
          />
          <p>vialle construction</p>
          <div className="reseaux">
            <Insta />
            <Facebook />
            <TikTok />
          </div>
        </div>
        <div className="header-right">
          <ul>
            <NavLink
              to={"/"}
              className={({ isActive }) => (isActive ? "nav-active2" : "lien2")}
            >
              Accueil
            </NavLink>
            <NavLink
              to={"/Services"}
              className={({ isActive }) => (isActive ? "nav-active2" : "lien2")}
            >
              Services
            </NavLink>
            <NavLink
              to={"/Realisations"}
              className={({ isActive }) => (isActive ? "nav-active2" : "lien2")}
            >
              Réalisations
            </NavLink>
            <NavLink
              to={"/Ensavoirplus"}
              className={({ isActive }) => (isActive ? "nav-active2" : "lien2")}
            >
              Nous connaitre
            </NavLink>
            <NavLink
              to={"/Partenaires"}
              className={({ isActive }) => (isActive ? "nav-active2" : "lien2")}
            >
              Partenaires
            </NavLink>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
